import {t} from "../../../i18n";

const dailyBuildTime = 8;
const buildTimePerCubicMeter = 1 / 8 * dailyBuildTime; //Stunden pro m³ (8m³/Tag) ; Definition nach #13044

export async function recalculateBuildTime(uncutVolume, cutVolume) {
    let uncutBuildTime = uncutVolume * buildTimePerCubicMeter; //Std
    let cutBuildTime = cutVolume * buildTimePerCubicMeter; //Std
    let totalBuildTime = uncutBuildTime + cutBuildTime;
    setBuildingTimeUIValue(totalBuildTime);
}


function setBuildingTimeUIValue(totalBuildTime) {
    let convertedTimeString = convertToTimeString(totalBuildTime);
    $('#build-time-text').html(convertedTimeString);
}

function convertToTimeString(totalBuildTime) {
    let days = Math.floor(totalBuildTime / dailyBuildTime);
    let hours = Math.ceil(totalBuildTime % dailyBuildTime);

    if (hours >= dailyBuildTime) {
        hours -= dailyBuildTime;
        days += 1;
    }

    const daysString = days === 1 ? t("build_time_day") : t("build_time_days");
    const hoursString = hours === 1 ? t("build_time_hour") : t("build_time_hours");

    if (hours === 0) {
        return '<b>' + days + ' ' + daysString + ' </b>';
    } else if (days === 0) {
        return hours + ' ' + hoursString;
    } else {
        return '<b>' + days + ' ' + daysString + ' </b>' + hours + ' ' + hoursString;
    }
}
